import { Route } from "@angular/router";
import { PanielVendasPage } from "./painel-vendas.page";

export const PainelVendasRouter: Route[] = [
  { path: 'painel-vendas', component: PanielVendasPage }
];
